import Const from 'constants';

let RangeOfOutcomes = {
    setRangeOfOutcomesFromStorage(value) {
        return (dispatch) => {
            dispatch(this.setRangeOfOutcomes(value, {saveToStorage: false}));
        };
    },

    setRangeOfOutcomes(value, options = {}) {
        return (dispatch) => {
            const {saveToStorage = true} = options;

            dispatch({
                type: Const.SET_RANGE_OF_OUTCOMES,
                value,
            });

            saveToStorage && dispatch(
                this.saveDataToStorage('rangeOfOutcomes', function (state) {
                    const {rangeOfOutcomes} = state;
                    return rangeOfOutcomes.getRangeOfOutcomes();
                }),
            );
        };
    },

    setRangeOfOutcomesByPositionsFromStorage(data) {
        return {
            type: Const.SET_RANGE_OF_OUTCOMES_BY_POSITIONS,
            data,
        };
    },

    setRangeOfOutcomesByPositions(positions, value) {
        return (dispatch, getState) => {
            const {rangeOfOutcomesByPositions} = getState();

            const data = rangeOfOutcomesByPositions.mergeItems({positions, value});

            dispatch({
                type: Const.SET_RANGE_OF_OUTCOMES_BY_POSITIONS,
                data,
            });

            dispatch(
                this.saveDataToStorage('rangeOfOutcomesByPositions', function (state) {
                    const {rangeOfOutcomesByPositions} = state;

                    return rangeOfOutcomesByPositions.getAllAsArr();
                }),
            );
        };
    },
};

export default RangeOfOutcomes;
